import { useLocation } from "react-router-dom";

import { AppLayoutProps } from "../../types/components.types";

import ErrorBoundary from "./ErrorBoundary";
import Footer from "./Footer";
import Header from "./Header";
import Navbar from "./Navbar";
import ProfileIcon from "./ProfileIcon";

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <div className="app-container">
      <Navbar />
      <div className="main-content-area">
        <Header />
        <main className="content">
          <ProfileIcon />
          {/* If a page crashes while rendering, keep the navbar usable and clear the error when the user navigates to another page. */}
          <ErrorBoundary level="page" resetKey={pathname}>
            {children}
          </ErrorBoundary>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default AppLayout;
